import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TenantService } from '../services/tenant.service';
import { StorageService } from '../services/storage.service';

/**
 * Interceptor para agregar headers específicos del tenant
 * - Agrega X-Tenant header con el slug del tenant
 * - Usa el token correcto (employee token para rutas de tenant)
 */
export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const tenantService = inject(TenantService);
  const storageService = inject(StorageService);

  // Clonar la petición para modificarla
  let modifiedReq = req.clone();

  // Si la petición es a rutas de tenant, agregar header y token
  if (req.url.includes('/tenant/')) {
    // IMPORTANTE: Detectar el tenant siempre desde el hostname
    // No confiar en el servicio porque puede no estar inicializado
    let tenantSlug = tenantService.detectTenantFromDomain();
    
    console.log('🔍 Tenant Interceptor - URL:', req.url);
    console.log('🌐 Hostname:', window.location.hostname);
    console.log('🏢 Tenant Slug detectado:', tenantSlug);
    
    // Agregar X-Tenant header si existe el tenant (incluyendo para login y auto-login)
    if (tenantSlug) {
      modifiedReq = modifiedReq.clone({
        setHeaders: {
          'X-Tenant': tenantSlug
        }
      });
      console.log('✅ Header X-Tenant agregado:', tenantSlug);
    } else {
      console.warn('⚠️ No se detectó tenant slug - El header X-Tenant no será agregado');
      console.warn('⚠️ Esto causará errores en rutas de tenant');
    }

    // Usar employee token para rutas protegidas (no para login ni auto-login)
    if (!req.url.includes('/login') && !req.url.includes('/auto-login')) {
      const employeeToken = storageService.getEmployeeToken();
      if (employeeToken) {
        modifiedReq = modifiedReq.clone({
          setHeaders: {
            'Authorization': `Bearer ${employeeToken}`
          }
        });
        console.log('🔑 Employee token agregado a la petición');
      }
    }
  }

  return next(modifiedReq);
};
